import dom from '../lib/dom.js';
import { trackEvent } from '@finn-no/pulse-sdk';

const offerIdFromPath = (path) =>
    // path is something like /reise/restplasser/ut?offerId=3c7c4e24&searchclickthrough=true"
    new URL(`http://dummy.com${path}`).searchParams.get('offerId') ?? 'missing';
const toNumberOrUndefined = (numAsString) => {
    const num = parseInt(numAsString);

    if (isNaN(num)) {
        return undefined;
    } else {
        return num;
    }
};

export default function setupTrackDropIn({ root }) {
    const track = function (event) {
        const element = dom.closestWithTagName('a', event.target);
        const href = element.getAttribute('href');
        const departureCity = element.getAttribute('data-origin-city');
        const departureAirport = element.getAttribute('data-origin-airport');
        const arrivalCountry = element.getAttribute('data-country');
        // TODO what to do with region? Should the tracking schema be extended with non-flight support too
        // const arrivalRegion = element.getAttribute('data-region');
        const arrivalCity = element.getAttribute('data-destination');
        const price = element.getAttribute('data-price');
        const provider = element.getAttribute('data-brand');

        // Pulse tracker id: TRL_ev01 (see tracking section in README.md)
        trackEvent({
            type: 'Click',
            intent: 'Purchase',
            name: 'Purchase last minute',
            object: {
                id: offerIdFromPath(href),
                type: 'UIElement',
                elementType: 'Button',
                items: [
                    {
                        id: 'finntravel',
                        type: 'Travel',
                        travelType: 'last_minute',
                        departureCountry: 'Norge',
                        departureCity,
                        departureAirport,
                        destination: arrivalCountry,
                        arrivalCity,
                        // TODO arrivalAirport: 'TODO',
                        // TODO departureDate: 'TODO',
                        // TODO returnDate: 'TODO',
                        // TODO duration: 'TODO',
                        totalPrice: toNumberOrUndefined(price),
                        // TODO carrier: the tracking schema should really support provider vs brand, maybe carrier as a third for flight
                        provider,
                    },
                ],
            },
            target: {
                id: href,
                type: 'ExternalContent',
                name: 'Go to webpage',
                referralCommission: true,
                provider,
            },
            vertical: {
                name: 'travel',
                subVertical: 'last_minute',
            },
        });
    };
    dom.on(root, 'click', '[data-drop-in]', track);
}
